import { Box } from '../../../shared_components/UI/Box'
import styled from 'styled-components'
import { getRgbaValue } from '../../../utils/styling'

export const SectionTitleCont = styled(Box)`
  position: relative;
  z-index: 1;

  @media (max-width: 1000px) {
    text-align: center;
  }
`

export const SectionText = styled.h3`
  color: var(--text-primary, #fff);
  leading-trim: both;
  text-edge: cap;

  /* Web/Heading Proxima Nova/3XL/Ultra */
  font-family: var(--type-family-proxima-nova, 'Proxima Nova');
  font-size: var(--Heading-3XL-3XL-size, 48px);
  font-style: normal;
  font-weight: 900;
  line-height: var(--Heading-3XL-3XL-line-height, 48px); /* 100% */
  text-transform: uppercase;

  @media (max-width: 768px) {
    font-size: 38px;
    line-height: 40px; /* 105.263% */
    letter-spacing: -1.52px;
  }
`

export const SectionSubtext = styled.p`
  color: #fff;
  text-align: center;
  leading-trim: both;
  text-edge: cap;
  font-feature-settings: 'dlig' on, 'ss01' on;
  font-family: 'Space Grotesk';
  font-size: 20px;
  font-style: normal;
  font-weight: 400;
  line-height: 28px; /* 140% */
  letter-spacing: -0.8px;
`

export const CountdownTitle = styled.span`
  color: var(--White, #fff);
  text-align: right;
  font-feature-settings: 'ss01' on;
  font-family: 'Space Grotesk';
  font-size: 16px;
  font-style: normal;
  font-weight: 300;
  line-height: 24px; /* 150% */
  letter-spacing: 4.8px;
  text-transform: uppercase;
`

export const MaintenanceCountdownTitle = styled(CountdownTitle)`
  text-align: left;
  max-width: 200px;

  @media screen and (max-width: 768px) {
    font-size: 12px;
    letter-spacing: 2.2px;
    max-width: 150px;
  }
`

export const HeroInput = styled.input`
  display: flex;
  width: 523px;
  max-width: 100%;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;

  padding: 13px 16px;
  border-radius: 4px;
  border: 1px solid rgba(255, 255, 255, 0.08);
  background: rgba(255, 255, 255, 0.02);

  color: var(--white, #f6f8ff);
  font-feature-settings: 'ss01' on;
  -webkit-text-stroke-width: 1;
  -webkit-text-stroke-color: var(--white, #f6f8ff);
  font-family: 'Space Grotesk';
  font-size: 14px;
  font-style: normal;
  font-weight: 300;
  line-height: normal;

  ::placeholder {
    opacity: 0.5;
  }

  :active,
  :focus {
    outline: 1px solid var(--Yellow, #fdfd0f);
    margin-left: 1px;
  }
`

export const HeroInputMessage = styled.span<{
  isSuccess: boolean
  isError: boolean
}>`
  color: ${({ isSuccess, isError }) =>
    isSuccess ? 'var(--Green, #5cb85c)' : isError ? 'var(--Red, #ff623e)' : ''};
  font-feature-settings: 'ss01' on;
  font-family: 'Space Grotesk';
  font-size: 12px;
  font-style: normal;
  font-weight: 300;
  line-height: normal;
`

export const MetricCont = styled(Box)``

export const StyledMetricItem = styled(Box) <{}>`
  z-index: 100;
  min-width: 384px;
  max-width: 546px;
  width: 100%;
  position: relative;
  overflow: hidden;
  border-radius: var(--units-8, 8px);
  background: var(--surface-minimal-alpha-secondary, rgba(255, 255, 255, 0.08));

  @media (max-width: 768px) {
    width: 100%;
    min-width: auto;
  }
`

export const MetricTitle = styled.span`
  overflow: hidden;
  color: var(--text-primary, #fff);
  text-overflow: ellipsis;

  /* Web/Text/XL/Semibold */
  font-family: var(--type-family-space-grotesk, 'Space Grotesk');
  font-size: var(--Text-XL-XL-size, 20px);
  font-style: normal;
  font-weight: var(--type-weight-Semibold, 600);
  line-height: var(--Text-XL-XL-line-height, 24px); /* 120% */
`

export const VaultItemsCont = styled(Box)`
  position: relative;
  @media (max-width: 768px) {
    &::before {
      content: '';
      background: linear-gradient(to left, #030b11, transparent);
      height: 100%;
      width: 20%;
      position: absolute;
      right: -16px;
      z-index: 100;
    }
  }
`

export const VaultItemsScrollableCont = styled(Box)`
  @media (max-width: 768px) {
    overflow-y: hidden;
    overflow-x: scroll;
    ::-webkit-scrollbar {
      display: none;
    }
    -ms-overflow-style: none;
    scrollbar-width: none;
    position: relative;
    z-index: 10;
    padding-right: 100px; // space for scroll

    flex-direction: column;
    flex-wrap: wrap;
    height: 410px;
  }
`

export const VaultItemBox = styled(Box)`
  max-width: 47%;
  flex: 1 0 656px;

  img,
  video {
    width: 656px;
    height: 263px;
    object-fit: cover;
  }

  @media (max-width: 768px) {
    width: 100%;
    max-width: 307px;
    flex: 1 0 auto;
    img,
    video {
      width: 100%;
      height: 220px;
    }
  }
`

export const VaultItemTitle = styled.h4`
  color: #fff;
  font-feature-settings: 'ss01' on;
  font-family: 'Space Grotesk';
  font-size: 24px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
`

export const VaultItemText = styled.p`
  overflow: hidden;
  color: #fff;
  font-feature-settings: 'ss01' on;
  text-overflow: ellipsis;
  font-family: 'Space Grotesk';
  font-size: 14px;
  font-style: normal;
  font-weight: 300;
  line-height: 22px; /* 157.143% */
`

export const NFTCont = styled(Box)`
  @media (max-width: 1000px) {
    align-items: flex-start;
  }
`

export const NFTImage = styled.div`
  max-width: 30%;
  padding: 14.5px;
  border: 1px solid var(--Yellow, #fdfd0f);
  background: rgba(3, 11, 17, 0.01);
  backdrop-filter: blur(34.02566909790039px);

  @media (max-width: 1000px) {
    max-width: 100%;
    margin-top: 32px;
  }
`

export const NFTTitle = styled.h4`
  color: #fff;
  font-feature-settings: 'ss01' on;
  font-family: 'Space Grotesk';
  font-size: 48px;
  font-style: normal;
  font-weight: 700;
  line-height: 50px; /* 104.167% */
`

export const NFTText = styled.p`
  color: #fff;
  leading-trim: both;
  text-edge: cap;
  font-feature-settings: 'dlig' on, 'ss01' on;
  font-family: 'Space Grotesk';
  font-size: 20px;
  font-style: normal;
  font-weight: 400;
  line-height: 28px; /* 140% */
  letter-spacing: -0.8px;
`

export const NFTName = styled.p`
  color: var(--White, #fff);
  text-align: right;
  font-feature-settings: 'ss01' on;
  font-family: 'Space Grotesk';
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 24px; /* 150% */
  letter-spacing: 4.8px;
  text-transform: uppercase;

  padding-right: 14px;
`

export const NFTRandomText = styled(Box)`
  color: #fff;
  text-align: right;
  font-family: 'Space Grotesk';
  font-size: 6px;
  font-style: normal;
  font-weight: 400;
  line-height: 8px; /* 133.333% */

  span:first-of-type {
    opacity: 0.8;
  }

  span {
    opacity: 0.5;
  }
`

type GridPatternBackgroundProps = {
  right: number
  isOverflow?: boolean
}

export const GridPatternBackground = styled.div<GridPatternBackgroundProps>`
  background-image: url(${({ isOverflow }) =>
    `/zap-vault-grid${!isOverflow ? '' : '-overflow'}.png`});
  background-size: contain;
  position: absolute;
  top: calc(100% - (473px - 72px)); // 72px is for the padding bottom
  right: ${({ right }) => right}px;
  width: 180px;
  height: 473px;

  @media (max-width: 1000px) {
    right: 0;
  }
`

export const ChartBox = styled(Box)`
  .mobile-chart {
    display: none;
  }
  @media (max-width: 1000px) {
    .desktop-chart {
      display: none;
    }
    .mobile-chart {
      display: block;
      width: 500px;
      max-width: 100%;
      margin: auto;
    }
  }
`

export const CountdownCont = styled(Box) <{ bordered?: boolean }>`
  // border: ${({ bordered }) =>
    bordered ? '1px solid rgba(255, 255, 255, 0.05)' : 'none'};
  // background: rgba(3, 11, 17, 0.01);
  // backdrop-filter: blur(30.95237922668457px);
  // padding: 12px;
`

export const CountdownItemCont = styled(Box)`
  border: 1px solid rgba(255, 255, 255, 0.2);
  background: rgba(3, 11, 17, 0.4);
  backdrop-filter: blur(20px);

  padding: 18px;

  @media (max-width: 768px) {
    padding: 8px;
  }
`

export const VaultCountItemCont = styled(CountdownItemCont)`
  padding: 2px 6px;

  border-radius: var(--units-8, 8px);
  background: var(--surface-brand-invert, #080808);
  backdrop-filter: blur(40.83272171020508px);
`

export const CountdownValue = styled.span<{
  $color?: string
  hasEnded?: boolean
}>`
  color: ${({ $color, hasEnded }) =>
    $color ? $color : hasEnded ? '#fff' : 'var(--Yellow, #fdfd0f)'};
  leading-trim: both;
  text-edge: cap;
  font-feature-settings: 'dlig' on;
  font-family: 'Space Grotesk';
  font-size: 60px;
  font-style: normal;
  font-weight: 700;
  line-height: 45px;

  min-width: 78px;
  text-align: center;

  @media (max-width: 768px) {
    font-size: 40px;
    line-height: 28px;
    min-width: 40px;
  }
`

export const VaultCountValue = styled(CountdownValue)`
  min-width: 40px;

  color: var(--text-primary, #fff);
  text-align: center;
  text-shadow: 0px 0px 122.498px #fdfd0f;

  /* Web/Heading Space/5XL/Semibold */
  font-family: var(--type-family-space-grotesk, 'Space Grotesk');
  font-size: var(--Heading-5XL-5XL-size, 72px);
  font-style: normal;
  font-weight: var(--type-weight-Semibold, 600);
  line-height: var(--Heading-5XL-5XL-line-height, 76px); /* 105.556% */

  @media (max-width: 768px) {
    font-size: 36px;
    min-width: 24px;
    line-height: 36px;
  }
`

export const CountdownLabel = styled.span`
  color: #fff;
  text-align: right;
  font-family: 'Space Grotesk';
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 12px;

  @media (max-width: 768px) {
    font-size: 10px;
  }
`

export const VaultsSoldBox = styled(Box)``

export const VaultsSoldText = styled.span`
  color: #0a1111;
  text-align: right;

  /* Web/Heading Space/XL/Semibold */
  font-family: var(--type-family-space-grotesk, 'Space Grotesk');
  font-size: var(--Heading-XL-XL-size, 32px);
  font-style: normal;
  font-weight: var(--type-weight-Semibold, 600);
  line-height: var(--Heading-XL-XL-line-height, 36px); /* 112.5% */

  @media screen and (max-width: 768px) {
    font-size: 19.502px;
    line-height: 100%; /* 19.502px */
    letter-spacing: -0.195px;
  }
`

export const VaultsToNextPriceBox = styled(Box)`
  @media screen and (max-width: 768px) {
    align-items: flex-start;
    gap: 8px;
    margin-top: 16px;
  }
`

export const VaultsToNextPriceText = styled.span`
  color: var(--White, #fff);
  text-align: right;
  font-feature-settings: 'ss01' on;
  font-family: 'Space Grotesk';
  font-size: 16px;
  font-style: normal;
  font-weight: 300;
  line-height: 24px; /* 150% */
  letter-spacing: 4.8px;
  text-transform: uppercase;

  max-width: 205px;

  @media screen and (max-width: 768px) {
    max-width: 100%;
    text-align: left;
  }
`

export const VaultGraphicBox = styled(Box)`
  .gradient-border-left-cont {
    position: relative;
    left: 0;
    top: 0;
    width: 58px;
    height: 45px;
  }

  .gradient-border-left {
    border-radius: 34px;
    border: 1px solid transparent;
    background: linear-gradient(45deg, #fdfd0f 0%, #fdf50f 100%) border-box;
    mask: linear-gradient(45deg, #fdfd0f 0%, #fdf50f 100%) padding-box,
      linear-gradient(45deg, #fdfd0f 0%, #fdf50f 100%);
    mask-composite: destination-out;
    mask-composite: exclude;

    border: 1px solid transparent;
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
    border-right-width: 0;
    width: 58px;
    height: 45px;
  }

  .gradient-border-left-bottom-tip {
    background: white;
    width: 9px;
    height: 9px;
    display: block;
    position: absolute;
    right: 0;
    bottom: -4px;

    ::before {
      content: '';
      background: white;
      width: 3px;
      height: 3px;
      display: block;
      position: absolute;
      right: 0;
      left: 0;
      margin: 0 auto;
      top: -21px;
    }

    ::after {
      content: '';
      background: white;
      width: 3px;
      height: 3px;
      display: block;
      position: absolute;
      right: 0;
      left: 0;
      margin: 0 auto;
      bottom: -22px;
    }
  }

  .gradient-border-right-cont {
    position: absolute;
    right: 0;
    top: 0;
    width: 58px;
    height: 45px;
  }

  .gradient-border-right {
    border-radius: 34px;
    border: 1px solid transparent;
    background: linear-gradient(45deg, #fdf50f 0%, #f9bc0b 100%) border-box;
    mask: linear-gradient(45deg, #fdf50f 0%, #f9bc0b 100%) padding-box,
      linear-gradient(45deg, #fdf50f 0%, #f9bc0b 100%);
    mask-composite: destination-out;
    mask-composite: exclude;

    border: 1px solid transparent;
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
    border-left-width: 0;
    width: 58px;
    height: 45px;

    position: absolute;
    right: 0;
    top: 0;
  }

  .gradient-border-right-top-tip {
    background: white;
    width: 9px;
    height: 9px;
    display: block;
    position: absolute;
    left: 0;
    top: -4px;
  }

  .gradient-border-right-bottom-tip {
    background: white;
    width: 9px;
    height: 9px;
    display: block;
    position: absolute;
    left: 0;
    bottom: -4px;

    ::before {
      content: '';
      background: white;
      width: 3px;
      height: 3px;
      display: block;
      position: absolute;
      right: 0;
      left: 0;
      margin: 0 auto;
      top: -21px;
    }

    ::after {
      content: '';
      background: white;
      width: 3px;
      height: 3px;
      display: block;
      position: absolute;
      right: 0;
      left: 0;
      margin: 0 auto;
      bottom: -22px;
    }
  }

  .gradient-border-top {
    background: linear-gradient(45deg, #fdfd0f 0%, #fdf50f 65%, #f9bc0b 100%);
    width: 100%;
    height: 1px;

    position: absolute;
    top: 0;
    left: 58px; // width of the left border
    max-width: calc(
      100% - 58px - 316px - 20px - 58px
    ); // width of the left border + width of the text + padding of text to right border + width of the right border

    ::before {
      content: '';
      background: white;
      width: 9px;
      height: 9px;
      display: block;
      position: absolute;
      right: 0;
      top: 50%;
      transform: translateY(-50%);
    }
  }

  @media screen and (max-width: 768px) {
    display: none;
  }
`

export const VaultMobileGraphicBox = styled(Box)`
  @media screen and (min-width: 768px) {
    display: none;
  }
`

export const VaultGraphicImg = styled.img`
  position: relative;
  width: 100%;
  z-index: 100;
`

export const VaultGraphicImgMobile = styled.img`
  position: relative;
  width: 100%;
  z-index: 100;
`

export const VaultGraphicMobileProgressBar = styled.div`
  width: 100%;

  .progress-bar {
    width: 100%;
    background-color: #1d2429; /* Dark color for the remaining progress */
    border-radius: 35px; /* Rounded corners */
  }

  .progress {
    background: linear-gradient(
      to right,
      #fdfd0f 0%,
      #fdd712 85%,
      #fff3b4 95%,
      white 100%
    ); /* Gradient for the progress */
    height: 19px; /* Height of the progress bar */
    border-radius: 35px; /* Rounded corners */
    transition: width 0.5s ease-in-out; /* Smooth transition for changes in progress */
  }
`

export const VaultGraphicTotal = styled.span`
  span {
    color: #fff;
    leading-trim: both;
    text-edge: cap;
    font-family: 'Space Grotesk';
    font-size: 14px;
    font-style: normal;
    font-weight: 300;
    line-height: 100%; /* 14px */
    letter-spacing: -0.14px;
    text-transform: uppercase;

    padding-top: 8px;
  }
  em {
    text-align: right;
    leading-trim: both;
    text-edge: cap;
    font-family: 'Space Grotesk';
    font-size: 36.706px;
    font-style: normal;
    font-weight: 700;
    line-height: 100%; /* 36.706px */
    letter-spacing: -0.367px;
    text-transform: uppercase;

    background: linear-gradient(
      90deg,
      #f5be01 9.79%,
      #fdfd0f 59.38%,
      #f5bf01 97.86%
    );
    background-clip: text;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  }
`

export const VaultGraphicRegular = styled.span`
  color: rgba(253, 253, 15, 0.65);
  font-family: 'Space Grotesk';
  font-size: 14px;
  font-style: normal;
  font-weight: 300;
  line-height: 119%; /* 16.66px */
  letter-spacing: -0.14px;
  text-transform: uppercase;

  em {
    color: var(--Yellow, #fdfd0f);
    font-family: 'Space Grotesk';
    font-size: 14px;
    font-style: normal;
    font-weight: 700;
    line-height: 119%;
    letter-spacing: -0.14px;
    text-transform: uppercase;
  }
`

export const VaultGraphicBonus = styled.span`
  color: rgba(255, 255, 255, 0.65);
  text-align: right;
  font-family: 'Space Grotesk';
  font-size: 14px;
  font-style: normal;
  font-weight: 300;
  line-height: 119%; /* 16.66px */
  letter-spacing: -0.14px;
  text-transform: uppercase;

  em {
    color: #fff;
    font-family: 'Space Grotesk';
    font-size: 14px;
    font-style: normal;
    font-weight: 700;
    line-height: 119%;
    letter-spacing: -0.14px;
    text-transform: uppercase;
  }
`

export const VaultGraphicTopDesktop = styled(Box)`
  position: absolute;
  top: 0;
`

export const VaultGraphicTotalBoxDesktop = styled(Box)`
  position: absolute;
  top: -19px;
  right: calc(58px + 20px); // width of the left border + padding

  ${VaultGraphicTotal} {
    span {
      font-size: 16px;
      text-align: right;
      max-width: 136px;
      padding: 0;
    }
  }
`

export const VaultGraphicDesktopBar = styled(Box)`
  margin-top: -9px;
  width: 100%;
  max-width: calc(100% - ((58px * 2) + (16px * 2)));
  margin-left: auto;
  margin-right: auto;
`

export const VaultGraphicNumbers = styled(Box)`
  color: #fff;
  leading-trim: both;
  text-edge: cap;
  font-family: 'Space Grotesk';
  font-size: 7.059px;
  font-style: normal;
  font-weight: 300;
  line-height: 100%; /* 7.059px */
  letter-spacing: -0.071px;
  text-transform: uppercase;
  opacity: 0.6;

  margin-right: 2%;
`

export const VaultGraphicNumbersTop = styled(VaultGraphicNumbers)`
  //
  // same as gradient-border-top
  //
  width: 100%;
  position: absolute;
  left: 58px; // width of the left border
  max-width: calc(
    100% - 58px - 316px - 20px - 58px
  ); // width of the left border + width of the text + padding of text to right border + width of the right border

  top: -14px;

  @media screen and (max-width: 1000px) {
    > ${Box} {
      :first-of-type {
        display: none;
      }
    }

    > ${Box} {
      :last-of-type {
        gap: 12px;
      }
    }
  }
`

export const VaultGradientSquaresBox = styled(Box)`
  @media screen and (max-width: 1000px) {
    display: none;
  }
  margin-left: 12px;
`

export const VaultGraphicGradientSquare = styled.div<{ o?: number }>`
  height: 12px;
  width: 12px;
  background: #fdfd11;
  opacity: ${({ o }) => o};
`

export const BaseVaultCont = styled.div`
  display: flex;
  align-items: center;
  position: relative;
  top: 0;
  left: 0;
  right: 0;
  min-height: 563px; // height of content + gutters/padding
  height: 80dvh;
  width: 100%;
  z-index: 3;
  overflow: hidden;

  @media (max-width: 1000px) {
    align-items: flex-start;
    height: 988px;
  }
`

export const VaultHeroImagesCont = styled.div`
  position: absolute;
  top: 40%;
  transform: translateY(-50%);
  left: 0;
  right: 0;
  z-index: 2;

  @media (max-width: 1000px) {
    transform: none;
    top: auto;
    bottom: 64px;
  }

  .vault-box {
    margin: auto;

    @media (min-width: 1300px) {
      transform: translateX(calc(100% - (536px - 30%)));
    }

    @media (min-width: 1200px) {
      transform: translateX(calc(100% - (536px - 50%)));
    }

    @media (max-width: 1199px) {
      transform: translate(calc(100% - (536px - 70%)));
    }

    @media (max-width: 1000px) {
      transform: none;
      max-height: 400px;
    }
  }
`

export const VaultHero = styled.div`
  .vault-hero-content {
    z-index: 1;
  }
  .vault-lightning {
    position: absolute;
    top: 50%;
    right: 0;
    min-width: 60%;
    min-height: 100%;
    transform: translateY(-50%);

    @media (max-width: 1000px) {
    bottom: -10%;
    top: unset;
    transform: none;
    min-height: unset;
    max-width: unset;
    width: 110%;
    left: -10%;
    right: unset;
    height: unset;
    }

    @media (max-width: 768px) {

          bottom: 0;
    top: unset;
    transform: none;
    min-height: unset;
    max-width: unset;
    width: 120%;
    left: -20%;
    /* right: unset; */
    height: 330px;
    object-position: unset;
    object-fit: unset;
    }
  }
`

export const HeroBrandBackground = styled.div`
  background: ${({ theme }) => theme.colors.brandPrimary};
  position: absolute;
  top: -80px;
  left: 0;
  right: 0;
  height: calc(100% + 80px);
  width: 100%;
  //z-index: 1;
  overflow: hidden;
`

export const BrandBackground = styled.div`
  background: ${({ theme }) => theme.colors.brandPrimary};
  height: 100%;
  width: 100%;
`

export const GradientBottom = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  z-index: 10;
  right: 0;
  left: 0;
  bottom: 0;
  background: linear-gradient(
    180deg,
    transparent 0%,
    transparent 80%,
    ${({ theme }) => getRgbaValue(theme.semantics.zap.surface.primary, 1)} 95%
  );
  pointer-events: none;
  @media screen and (max-width: 768px) {
    background: linear-gradient(
      180deg,
      transparent 0%,
      transparent 90%,
      ${({ theme }) => getRgbaValue(theme.semantics.zap.surface.primary, 1)}
        97.5%
    );
  }
`

export const PayoutBar = styled.div`
  width: 100%;
  height: 20px;
  border-radius: 88px;
  position: relative;
  background: var(--surface-minimal-alpha-secondary, rgba(255, 255, 255, 0.08));

  ::after {
    content: '';
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    height: 20px;
    width: 75%;
    background: url('/zap-vault-bar.svg');
    background-repeat: no-repeat;
    border-radius: 88px;
  }
`

export const BarTitleBox = styled(Box)`
  @media (max-width: 768px) {
    justify-content: space-between;
  }
`
